module.exports = __webpack_public_path__ + "img/magnum-pdf.4253b623.svg";